/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summer_Occupied_SetpointInputs */



/**
* | output |
* | --- |
* | "Summer occupation setpoint" |
*
* @param {Summer_Occupied_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const summer_occupied_setpoint = /** @type {((inputs?: Summer_Occupied_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summer_Occupied_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer occupation setpoint")
	return /** @type {LocalizedString} */ ("Consigne occupation été")
});